export interface MessageAttachmentMedia {
  id: string;
  url: string;
  thumbnail_url: string;
  type: string;
  mime_type: string;
  filename: string;
  position: number;
  created_at: string;
  updated_at: string;
  duration?: number;
}

export const ATTACHMENT_STATUS = {
  pending: "pending",
  waiting_for_payment: "waiting_for_payment",
  refused_by_fan: "refused_by_fan",
  refused_by_creator: "refused_by_creator",
  refused: "refused",
  delivered: "delivered",
  paid: "paid",
  purchased: "purchased",
  to_deliver: "to_deliver"
} as const;

export type AttachmentStatus =
  (typeof ATTACHMENT_STATUS)[keyof typeof ATTACHMENT_STATUS];

export interface AttachmentPrice {
  amount: number;
  currency: string;
}

export interface AttachmentDiscount {
  reduce_price: AttachmentPrice;
  duration: string;
}

export interface MessageAttachmentData {
  id: string;
  status: AttachmentStatus;
  price: AttachmentPrice | number;
  old_price: AttachmentPrice | number | null;
  discount?: AttachmentDiscount | null;
  teaser: MessageAttachmentMedia | null;
  media: MessageAttachmentMedia[];
  duration?: number;
  url?: string;
}

export interface MessageMediaData {
  id: string;
  sender_id: string;
  receiver_id: string;
  date: string;
  type: string;
  content: string;
  status: string;
  read_at: string | null;
  attachment: MessageAttachmentData;
  live?: {
    booking_id: string;
    price: number;
    currency: string;
    duration: number;
    offer_status: string;
  };
}

export interface MessageMediaResponse {
  data: MessageMediaData[];
  not_found?: string[] | null;
}
